export const createElementFromHTML = (
  tagName,
  className = "",
  content = ""
) => {
  const el = document.createElement(tagName);
  el.innerHTML = content.trim();
  if (className !== "") el.className = className;
  return el;
};

export const addClass = (el, className) => {
  el.classList.add(className);
};
export const removeClass = (el, className) => {
  el.classList.remove(className);
};

export const hasClass = (el, className) => {
  return el.classList.contains(className);
};
